// Golden Spheres Three.js Hero - Full Width Behind Text
(async function() {
    try {
        const THREE = await import('https://unpkg.com/three@0.178.0/build/three.module.js');

        class GoldenSpheresHero {
            constructor() {
                this.scene = new THREE.Scene();
                const heroSection = document.querySelector('.hero-section');
                if (!heroSection) return;

                const rect = heroSection.getBoundingClientRect();
                this.camera = new THREE.PerspectiveCamera(50, rect.width / rect.height, 0.1, 1000);
                this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
                this.clock = new THREE.Clock();
                this.spheres = [];
                this.isPaused = false;
                this.heroSection = heroSection;

                this.setupRenderer();
                this.setupCamera();
                this.createSphereGrid();
                this.animate();
                this.setupResize();
            }

            setupRenderer() {
                const rect = this.heroSection.getBoundingClientRect();
                this.renderer.setSize(rect.width, rect.height);
                this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
                this.renderer.setClearColor(0x000000, 0);

                this.renderer.domElement.style.cssText = "position:absolute;top:0;left:0;width:100%;height:100%;z-index:0;pointer-events:none;";

                this.heroSection.style.position = 'relative';
                this.heroSection.insertBefore(this.renderer.domElement, this.heroSection.firstChild);
            }

            setupCamera() {
                this.camera.position.set(0, 45, 100);
                this.camera.lookAt(0, 0, 0);
            }

            createSphereGrid() {
                const goldColor = new THREE.Color(0xd4a843);
                const sphereGeometry = new THREE.SphereGeometry(0.5, 12, 12);
                const sphereMaterial = new THREE.MeshBasicMaterial({
                    color: goldColor,
                    transparent: true,
                    opacity: 0.9
                });

                const gridWidth = 240;
                const gridDepth = 120;
                const spacingX = 16;
                const spacingZ = 16;

                for (let x = -gridWidth/2; x <= gridWidth/2; x += spacingX) {
                    for (let z = -gridDepth/2; z <= gridDepth/2; z += spacingZ) {
                        const sphere = new THREE.Mesh(sphereGeometry, sphereMaterial.clone());
                        sphere.position.set(x, 0, z);
                        sphere.userData = {
                            baseX: x,
                            baseZ: z,
                            phase: Math.random() * Math.PI * 2
                        };
                        this.scene.add(sphere);
                        this.spheres.push(sphere);
                    }
                }

                const lineColor = new THREE.Color(0xb8923a);
                const lineMaterial = new THREE.LineBasicMaterial({
                    color: lineColor,
                    transparent: true,
                    opacity: 0.25
                });

                this.connectionLines = [];
                const cols = Math.ceil(gridWidth / spacingX) + 1;

                for (let i = 0; i < this.spheres.length; i++) {
                    const col = i % cols;
                    const row = Math.floor(i / cols);

                    if (col < cols - 1) {
                        const rightIdx = i + 1;
                        if (rightIdx < this.spheres.length) {
                            const geometry = new THREE.BufferGeometry();
                            const positions = new Float32Array(6);
                            geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
                            const line = new THREE.Line(geometry, lineMaterial.clone());
                            line.userData = { startIdx: i, endIdx: rightIdx };
                            this.scene.add(line);
                            this.connectionLines.push(line);
                        }
                    }

                    const bottomIdx = i + cols;
                    if (bottomIdx < this.spheres.length) {
                        const geometry = new THREE.BufferGeometry();
                        const positions = new Float32Array(6);
                        geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
                        const line = new THREE.Line(geometry, lineMaterial.clone());
                        line.userData = { startIdx: i, endIdx: bottomIdx };
                        this.scene.add(line);
                        this.connectionLines.push(line);
                    }
                }
            }

            animate() {
                if (this.isPaused) return;
                requestAnimationFrame(() => this.animate());

                const time = this.clock.getElapsedTime();

                this.spheres.forEach((sphere) => {
                    const { baseX, baseZ, phase } = sphere.userData;

                    const wave1 = Math.sin(baseX * 0.12 + time * 0.077 + phase) * 5;
                    const wave2 = Math.cos(baseZ * 0.1 + time * 0.057) * 4;
                    const wave3 = Math.sin((baseX + baseZ) * 0.06 + time * 0.043) * 3;

                    sphere.position.y = wave1 + wave2 + wave3;

                    const brightness = 0.5 + (sphere.position.y + 12) / 24 * 0.5;
                    sphere.material.opacity = Math.min(0.95, Math.max(0.3, brightness));
                });

                this.connectionLines.forEach((line) => {
                    const { startIdx, endIdx } = line.userData;
                    const startSphere = this.spheres[startIdx];
                    const endSphere = this.spheres[endIdx];

                    if (startSphere && endSphere) {
                        const positions = line.geometry.attributes.position.array;
                        positions[0] = startSphere.position.x;
                        positions[1] = startSphere.position.y;
                        positions[2] = startSphere.position.z;
                        positions[3] = endSphere.position.x;
                        positions[4] = endSphere.position.y;
                        positions[5] = endSphere.position.z;
                        line.geometry.attributes.position.needsUpdate = true;
                    }
                });

                this.camera.position.y = 45 + Math.sin(time * 0.017) * 5;
                this.camera.position.x = Math.sin(time * 0.011) * 12;
                this.camera.lookAt(0, 0, 0);

                this.renderer.render(this.scene, this.camera);
            }

            setupResize() {
                window.addEventListener('resize', () => {
                    const rect = this.heroSection.getBoundingClientRect();
                    this.camera.aspect = rect.width / rect.height;
                    this.camera.updateProjectionMatrix();
                    this.renderer.setSize(rect.width, rect.height);
                });
            }
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                window.goldenSpheresHero = new GoldenSpheresHero();
            });
        } else {
            window.goldenSpheresHero = new GoldenSpheresHero();
        }

    } catch (error) {
        console.error('Golden Spheres Hero error:', error);
    }
})();
